import React from 'react'
import styled from 'styled-components'
import LinkHandler from '../utils/LinkHandler'

const Wrapper = styled.div`
  width: 100%;
  background-image: url('${STATICS_PATH}images/plague/background.jpg');
  background-position: left;
  background-size: cover;
  box-sizing: border-box;
  font-family: Barlow, sans-serif;
  color: white;
  font-size: 14px;
  margin-bottom: 20px;
`

const MainBox = styled.div`
  display: flex;
  justify-content: space-evenly;
`

const MainBoxItem = styled.div`
  display: inline-flex;
  width: 50%;
  padding: 20px;
  flex-direction: column;
`

const Paragraph = styled.div`
  text-align: center;
  line-height: 1.2;

  &:not(:first-of-type) {
    margin-top: 10px;
  }
`

const Bold = styled.span`
  font-size: 18px;
  font-weight: bold;
  display: block;
  text-align: center;
`

const BoldForImage = styled(Bold)`
  margin-top: -28px;
  z-index: 42;
  font-size: 17px;
`

const InfoBox = styled.span`
  background: rgba(255,255,255,.1);
  color: #fff;
  border: 1px solid rgba(255,255,255,.2);
  border-radius: 3px;
  padding: 3px 6px;
  display: inline-block;
  margin: 3px;
  font-size: 12px;
  font-weight: bold;
  line-height: 15px;
`

const Link = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
  }
`

const MainBoxItemLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`

const ImageHolder = styled.div`
  text-align: center;
  position: relative;
`

const Img = styled.img`
  width: 90%;
  margin: 0 auto;
`

const Articles = styled.div`
  display: flex;
  justify-content: space-evenly;
  background: rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  width: 100%;
`

const Article = styled.div`
  display: flex;
  padding: 15px 2%;
  font-size: 12px;
  line-height: 17px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  font-style: normal;
  
  &:not(:last-of-type) {
    border-right: 1px dashed rgba(255, 255, 255, 0.3);
  }
`

const ArticleLink = styled.a`
  color: inherit;
  text-decoration: none;
  
  &:hover {
    color: inherit;
  }
`

const ArticleImage = styled.img`
  border-radius: 50%;
  height: 40px;
  margin-right: 10px;
  float: left;
`

const ArticleText = styled.p`
  overflow: hidden;
  margin-bottom: 0;
`

const Radius = styled.span`
  display: block;
  background: rgba(255, 0, 0, 0.4);
  border: 1px solid #da1630;
  border-radius: 50%;
  position: absolute;
  opacity: 1;
  width: 10px;
  height: 10px;
  transform: translate(-50%,-50%);
  animation: pulse 7s ease-out infinite;
  animation-iteration-count: 3;
  animation-fill-mode: forwards;

  &.asia {
    top: 28%;
    left: 74%;
    height: 70px;
    width: 70px;
  }

  &.middle-east {
    top: 31%;
    left: 59%;
    height: 30px;
    width: 30px;
  }

  &.europe {
    top: 20%;
    left: 50%;
    height: 40px;
    width: 40px;
  }

  &.n-america-east {
    top: 18%;
    left: 28%;
  }

  &.n-america-north-west {
    top: 15%;
    left: 15%;
  }
  
  &.n-america-south-west {
    top: 22%;
    left: 15%;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
      transform: translate(-50%,-50%) scale(1);
    }

    10% {
      opacity: 0;
      transform: translate(-50%,-50%) scale(0.9);
    }

    20% {
      opacity: 0;
      transform: translate(-50%,-50%) scale(0.3);
    }

    100% {
      opacity: 1;
      transform: translate(-50%,-50%) scale(1);
    }
  }
`

export default (props) => {
  const {
    widget: {
      utmSource,
      utmMedium,
      boxes
    }
  } = props
  const mainBoxUrl = 'https://zpravy.aktualne.cz/zahranici/koronavirus-na-mape-sveta-kde-je-nejvic-nemocnych/r~3a5ccb9a620011eaa7deac1f6b220ee8/'
  const mainBoxLink = new LinkHandler(mainBoxUrl).mergeUTMParams({ utmSource, utmMedium, utmContent: 'covid' }).link

  return (
    <Wrapper>
      <MainBox>
        <MainBoxItem>
          <Paragraph>
            Informace <Bold>o KORONAVIRU</Bold>
          </Paragraph>
          <Paragraph>
            V případě zdravotních obtíží volejte linku <InfoBox>1212</InfoBox> nebo svého praktického lékaře.
          </Paragraph>
          <Paragraph>
            Nonstop linka - Státní zdravotní ústav:<br/>
            <InfoBox>724 810 106</InfoBox>
            <InfoBox>725 191 367</InfoBox>
          </Paragraph>

          <Paragraph>
            Kde hledat informace:<br/>
            <InfoBox><Link href='http://www.szu.cz'>www.szu.cz</Link></InfoBox>
            <InfoBox><Link href='http://www.mzcr.cz'>www.mzcr.cz</Link></InfoBox>
          </Paragraph>
        </MainBoxItem>
        <MainBoxItem>
          <MainBoxItemLink href={mainBoxLink}>
            <ImageHolder>
              <Img src='https://graphics.stdout.cz/2dfd0791577ee1244b06632d98213259/mapa._3_.png' alt='mapa'/>
              <BoldForImage>KORONAVIRUS NA MAPĚ SVĚTA: KDE JE NEJVÍC NEMOCNÝCH A JAK SE NÁKAZA ŠÍŘÍ?</BoldForImage>
              <Radius className='asia'/>
              <Radius className='middle-east'/>
              <Radius className='europe'/>
              <Radius className='n-america-east'/>
              <Radius className='n-america-north-west'/>
              <Radius className='n-america-south-west'/>
            </ImageHolder>
          </MainBoxItemLink>
        </MainBoxItem>
      </MainBox>
      <Articles>
        {
          boxes.map(({ link, images, title }, index) => (
            <Article key={index}>
              <ArticleLink href={new LinkHandler(link).mergeUTMParams({ utmSource, utmMedium, utmContent: 'covid' }).link}>
                <ArticleImage src={images['1_1']}/>
                <ArticleText>{title}</ArticleText>
              </ArticleLink>
            </Article>
          ))
        }
      </Articles>
    </Wrapper>
  )
}
